
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2kmFP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2f37934c6709a990262261073c8d0052>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1b1f0989a272190c$var$_react = $1b1f0989a272190c$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $1b1f0989a272190c$var$_baseNew = $1b1f0989a272190c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1b1f0989a272190c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RadioChecked".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for the selected state of radio controls.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1b1f0989a272190c$var$RadioCheckedIcon = (props)=>/*#__PURE__*/ $1b1f0989a272190c$var$_react.default.createElement($1b1f0989a272190c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
    }, props));
$1b1f0989a272190c$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
var $1b1f0989a272190c$var$_default = module.exports.default = $1b1f0989a272190c$var$RadioCheckedIcon;

});


//# sourceMappingURL=radio-checked.ee519c22.js.map
